import { ColorScheme } from 'mini-color-utils/lib/ColorScheme';
import { ExtensionHeaderProps } from 'extension-header/lib/schema/ExtensionHeaderProps';
import { HeaderIconType } from './HeaderIcon.types';

export enum TitleJustification {
    CENTER = 1,
    LEFT,
    RIGHT,
}

export interface HeaderProps extends ExtensionHeaderProps {
    title?: string | JSX.Element;
    secondaryHeaderItem?: string | JSX.Element;
    leftIcon?: HeaderIconType;
    rightIcon?: HeaderIconType;
    colorScheme?: ColorScheme;
    color?: string;
    backgroundColor?: string;
    showBorder?: boolean;
    titleStyles?: string;
    secondaryHeaderItemStyles?: string;
    titleAriaLabel?: string;
    secondaryHeaderAriaLabel?: string;
    headerStyles?: string;
    headerAriaLabel?: string;
    titleJustification?: TitleJustification;
    ariaLevel?: number;
    secondaryTitleRef?: React.RefObject<any>;
    wrapLeftIconsInContainer?: boolean;
    wrapRightIconsInContainer?: boolean;
    shouldTitleContainerBeAccessible?: boolean;
    hideExtensionHeader?: boolean;
    hideMailPeopleBackButton?: boolean;
    hideCalendarBackButton?: boolean;
}
